module.exports = __webpack_public_path__ + "media/images/oyako_no_heya_fav-ca491b08052fd791b5fa0b16fc70f16a.png";